export const armReactKeys = (arms)=>{
    const occurrencesByContent = new Map();
    return arms.map((arm)=>{
        var _occurrencesByContent_get;
        const content = JSON.stringify(arm);
        const occurrence = (_occurrencesByContent_get = occurrencesByContent.get(content)) !== null && _occurrencesByContent_get !== void 0 ? _occurrencesByContent_get : 0;
        occurrencesByContent.set(content, occurrence + 1);
        return "".concat(content, "#").concat(occurrence);
    });
};
